<template>
	<div class="jobs">
    <div class="product_title" id="target1" v-if="productShow.length>2" >
      <a @click="clickLink(1)" v-if="productValueShowList[0].status" :class="titleActive=='1'?'titleActive':'item'" href="#target1">产品优势 </a>
      <a @click="clickLink(2)" v-if="productValueShowList[1].status" :class="titleActive=='2'?'titleActive':'item'" href="#target2">产品功能 </a>
      <a @click="clickLink(3)" v-if="productValueShowList[2].status" :class="titleActive=='3'?'titleActive':'item'" href="#target3">视频教程 </a>
      <a @click="clickLink(4)" v-if="productValueShowList[3].status" :class="titleActive=='4'?'titleActive':'item'" href="#target4">客户案例 </a>
      <a @click="clickLink(5)" v-if="productValueShowList[4].status" :class="titleActive=='5'?'titleActive':'item'" href="#target5">文档与工具 </a>
    </div>
<!--    产品优势-->
    <div class="advantages" style="padding-top: 80px" v-if="productValueShowList[0].status" >
      <div class="top">
        <div class="color333 title"  >产品优势</div>
        <div class="discribe">{{productDetail.xcProductAdvantage&&productDetail.xcProductAdvantage.advantageSubheading||''}}</div>
      </div>
      <div class="content">
        <div   v-if="productDetail.xcProductAdvantage.advantageStyleShow==1" class="content_item" v-for="item in productDetail.xcProductAdvantage.xcProductAdvantageContentList">
            <p>{{item.advantageTitle||''}}</p>
          <div>
            <img :src="item.advantageIconUrl"/>
          </div>
          <div class="item_content" >
            <p>
            {{item.advantageDescription||''}}
            </p>
          </div>
        </div>
        <div v-if="productDetail.xcProductAdvantage&&productDetail.xcProductAdvantage.advantageStyleShow==2" class="content_item_2" v-for="item in productDetail.xcProductAdvantage&&productDetail.xcProductAdvantage.xcProductAdvantageContentList">
          <div>
            <img :src="item.advantageIconUrl"/>
          </div>
          <div class="item_content">
            <p>{{item.advantageTitle||''}}</p>
            <p>{{item.advantageDescription||''}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="product_features" id="target2" v-if="productValueShowList[1].status" >
      <div class="top">
        <div class="color333 title"  >产品功能</div>
        <div class="discribe">{{productDetail.xcProductFunction
            .functionSubheading||''}}</div>
      </div>
      <div class="features"  >
      <div class="content_item" v-for="item in productDetail.xcProductFunction
.xcProductFunctionContentList
">
        <div v-if="productDetail.xcProductFunction.functionStyleShow==1" class="left_border"></div>
        <div v-if="productDetail.xcProductFunction.functionStyleShow==2" class="top_border"></div>
        <div class="item_top">
          <div class="dot"></div>
          <div class="title">{{item.functionTitle||''}}</div>
        </div>
        <div  class="features_discribe">{{item.functionDescription||''}}</div>
      </div>
      </div>
    </div>
<!--v-if="index < 3 || showAll"-->
    <div class="advantages"  id="target3" v-if="productValueShowList[2].status" >
      <div class="top">
        <div class="color333 title">视频教程</div>
        <div class="discribe">{{productDetail.xcProductFunction
            .videoSubheading||''}}</div>
      </div>
      <div class="video_content">
        <div class="video_content_item cursorPointer"  @click="videoClick(item)" v-for="(item,index) in productDetail.xcProductVideo
.xcProductVideoContentList" v-if="index < 3 || showAll">
            <img class="video_img" :src="item.coverUrl"/>
            <p>{{item.videoTitle||''}}</p>
          <img class="video_icon" src="https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/37db8ef0-6072-4a32-93c3-3c98334d08fc.png"/>
        </div>
      </div>
        <button v-if="productDetail.xcProductVideo
.xcProductVideoContentList.length>3" class="showAllBtn" @click="showAll = !showAll">{{ showAll?'收起':'查看更多视频' }}</button>
    </div>


    <div class="customer" id="target4" v-if="productValueShowList[3].status">
      <div class="top">
        <div class="color333 title"  >客户案例</div>
        <div class="discribe">{{productDetail.xcProductCustomer.customerSubheading||''}}</div>
      </div>
      <div class="features">
        <swiper  :options="swiperOptions" style="width:1190px;height: 379px;border-radius: 10px;position: relative">
        <swiper-slide v-for="(item,index) in productDetail.xcProductCustomer.xcProductCustomerContentList
" :key="index">
          <div  class="swiperCard" >
          <div>
          <img    :src="item.customerIconUrl" alt="轮播图图片"/>
          </div>
              <div class="swiperContent" >
                <div class="title">{{item.customerTitle}}</div>
                <div class="customerDescription">{{item.customerDescription}}</div>
              </div>
          </div>
        </swiper-slide>
        <!-- 分页器 -->
        <!-- 上一张按钮 -->
        <div class="swiper-pagination" slot="pagination"></div>

        </swiper>
        <div class="bgSite"></div>
        <div class="swiper-button-prev" ></div>
        <!-- 下一张按钮 -->
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="customer" id="target5" v-if="productValueShowList[4].status">
      <div class="top">
        <div class="color333 title"  >文档与工具</div>
        <div class="discribe">{{productDetail.xcProductWord.wordSubheading||''}}</div>
      </div>
      <div class="Documentation">
        <div class="Documentation_item" v-for="item in productDetail.xcProductWord.xcProductWordContentList">
          <div class="top">
            <p>{{item.contentTitle}}</p>
          </div>
          <div class="content">
            <div class="content_top">{{item.contentSubheading}}</div>
            <div class="content_center">
              <div @click="documentClick(vItem)" class="item" v-for="vItem in item.xcProductWordContentDetailList">
                {{vItem.contentDetailTitle||''}}

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer ></Footer>
	</div>
</template>

<script>
	import {
		getJson
	} from "@/utils/axios";
	import axios from 'axios'
  import Footer from "@/components/layout/footer";
	export default {
    props:{
      productDetail: {
        type: Object,
        default: () => {},
      }
    },
    components: {
      Footer
    },
    watch:{
      productDetail:{
        handler(){
          this.generateProductShowStatus()
        },
        deep:true
      }
    },
		data() {
			return {
        productShow:[],
        productValueShowList: [
          {
            value:'1',
            status:1,
          },
          {
            value:'2',
            status:1,
          },
          {
            value:'3',
            status:1,
          },
          {
            value:'4',
            status:1,
          },
          {
            value:'5',
            status:1,
          },
        ],
        showAll:false,
        images: [
          'https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/9f42891e-0958-4120-b8da-ab862df2442e.png', // 需替换为实际图片路径
          'https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/37db8ef0-6072-4a32-93c3-3c98334d08fc.png',
          'https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/9f42891e-0958-4120-b8da-ab862df2442e.png'
        ],
        swiperOptions: {
          autoplay: {
            delay: 3000, // 自动播放间隔，单位为毫秒
            disableOnInteraction: false // 用户交互后不停止自动播放
          },
          speed: 1000, // 切换幻灯片的速度，单位为毫秒
          pagination: {
            el: '.swiper-pagination',
            clickable: true // 分页器可点击
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        // 详情
        titleActive:'1',
        productShowList: [
          {
            label: '产品优势',
            value: '1'
          },
          {
            label: '产品功能',
            value: '2'
          },
          {
            label: '视频教程',
            value: '3'
          },
          {
            label: '客户案例',
            value: '4'
          },
          {
            label: '文档与工具',
            value: '5'
          }
        ],
				JobDetailUrl: '',
				typeActive: 0,
				checkMore: 0,
				typeList: [{
					key: '31',
					title: '物流行业专区',
					prop: 'category_l1',
					url: 'https://xdxdd3-weapp-1257088705.cos.ap-guangzhou.myqcloud.com/wxapp/website/main/type_01.png'

				}, {
					key: '5',
					title: '家政行业专区',
					prop: 'category_l1',
					url: 'https://xdxdd3-weapp-1257088705.cos.ap-guangzhou.myqcloud.com/wxapp/website/main/type_02.png'

				}, {
					key: '6',
					title: '工厂专区',
					prop: 'category_l1',
					url: 'https://xdxdd3-weapp-1257088705.cos.ap-guangzhou.myqcloud.com/wxapp/website/main/type_03.png'
				}],
				workList: [{
					key: '',
					prop: '',
					title: '全部',
				}, {
					key: '日结',
					prop: 'settle_type',
					title: '日结工',
				}, {
					key: '小时工',
					prop: 'settle_type',
					title: '小时工',
				}, {
					key: '计件',
					prop: 'settle_type',
					title: '计件岗',
				}, {
					key: true,
					prop: 'long_term_flg',
					title: '全职岗位',
				}, ],
				hotJobsList: []
			}
		},
		methods: {
      generateProductShowStatus() {
        const productShow=this.productDetail.productShow.split(',');
        console.log(productShow,'productShow')
        this.productShow=productShow;
        const list= this.productShowList.map(item => ({
          value: item.value,
          status: productShow.includes(item.value) ? 1 : 0
        }));
        this.productValueShowList = list;
        console.log(this.productValueShowList,'this.productValueShowList')
        // const firstActiveItem = this.productValueShowList.find(item => item.status === 1);
        // this.activeName = firstActiveItem.value;
        // console.log(firstActiveItem,'firstActiveItem')
      },
      videoClick(item){
        if(!item.videoUrl) return
        window.open(item.videoUrl)
      },
      documentClick(item){
        if(!item.contentDetailUrl) return
        window.open(item.contentDetailUrl)
      },
      clickLink(value){
        this.titleActive = value
      },
			sign(item){
				this.JobDetailUrl = '';
				axios(
					{
						url: 'https://chat-web.din-job.com/getUnlimitedQRCode',
						method: 'POST',
						data: {
							appId: 'wx6454d9fb93a6cae5',
							secret: 'd69ff7b6c81858a395f428d3d622de72',
							appName: 'ddlg',
							jobId: item.id,
						},
						headers: { 'content-type': 'application/x-www-form-urlencoded'},
					}
				).then( (res) => {
					this.JobDetailUrl = res.data.data;
				}).catch((err) => {
					console.log(err);
					this.$message({message: '提交异常，请联系管理员', type: 'error'});
				});
			},
			checkmore(value) {
				if ((this.checkMore >= this.workList.length - 9) && value > 0) {
					return
				}
				if ((this.checkMore <= 0) && value < 0) {
					return
				}
				this.checkMore += value
			},

			getJobTypes() {
				getJson('/api/mst/jobCategoryL1', {}, res => {
					res.map(item => {
						const obj = {
							key: item.id,
							prop: 'category_l1',
							title: item.category_name,
						}
						this.workList.push(obj);
					});
				});
			},
			filterJob(item, index) {
				this.typeActive = index
				this.$router.push( { path: '/home/jobs', query: { prop: item.prop, key: item.key, title: item.title, isType: item.url ? false : true } } );
			}
		},
		created() {
      this.generateProductShowStatus()
			// this.getJobTypes();
			// this.getHotJobs();
		}
	}
</script>

<style scoped lang="scss">
page{
  background: #F5F9FF;
}

.swiper-button-prev{
  left: auto;
  right: 260px !important;
  top: 290px;
  //bottom: 70px;
  background-image: url("https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/edb73bb1-2b06-4da0-9295-892b8f143bf4.png");
  background-size: 100% 100%;
  width: 70px;
  height: 59px;
  &::after{
    content: '';
  }
}
.swiper-button-next{
  left: auto;
  right: 170px !important;
  top: 290px;
  background-image: url("https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/0cf91646-69bb-4064-bad7-27797741135d.png");
  background-size: 100% 100%;
  width: 70px;
  height: 59px;
  &::after{
    content: '';
  }
}
.swiperCard{
  position: relative;
  width: 1190px;
  height: 379px;
  background: #FFFFFF;
  box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.08);
  display: flex;
  padding: 66px 10px 66px 47px;
  //justify-content: space-between;
  img{
    width: 432px;
    height: 246px;
  }

  .swiperContent{
    width: 547px;
    height: 154px;
    padding-top: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    padding-bottom: 16px;
    margin-left: 58px;
    border-left: 2px solid #EAEAEA;
    padding-left: 59px;
    text-align: left;
    .title{
      font-weight: 500;
      font-size: 24px;
      color: #333333;
    }
    .customerDescription{
      word-wrap:break-word;
      word-break:normal;
      margin-top: 36px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
}
.color333{
  color: #333;
}
.product_title{
  position: absolute;
  width: 1176px;
  height: 80px;
  background: #fff;
  box-shadow: 0px 10px 15px 0px rgba(28,81,163,0.05);
  border-radius: 4px;
  //top: 704px;
  left: 50%;
  top: -40px;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  line-height: 80px;
  cursor: pointer;
  .titleActive{
    border-bottom: 2px solid #1C51A3;
    font-weight: 550;
    font-size: 16px;
    color: #1C51A3;
  }
  .item{
    color: #303030;
    font-size: 16px;
    font-weight: 500;
  }
}
.product_features{
  width: 100%;
  //text-align: center;
  background: #1C51A3;
  margin-top:80px;
  padding: 120px 0 0px 0 ;
  .top{
    .title{
      color: #fff;
      font-size: 40px;
      font-weight: 550;
      line-height: 55px;
      text-align: center;
    }
    .discribe{
      color: #ccc;
      font-size: 24px;
      margin-top: 9px;
    }
  }
  .features{
    //width: 100%;
    //height: 777px;
    display: flex;
    padding-bottom: 114px;
    margin-top: 80px;
    flex-direction: column;
    align-items: center;

    .content_item{
      width: 1172px;
      //height: 136px;
      background: #FFFFFF;
      position: relative;
      box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.08);
      border-radius: 10px;
      margin-bottom: 20px;
      .left_border{
        position: absolute;
        width: 3px;
        left: 12px;
        top: 0;
        height: 100%;
        background-color: #1C51A3;
      }
      .top_border{
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #1C51A3;
        top: 20px;
      }
      .item_top{
        display: flex;
        padding:41px 0 0px 36px;
        .dot{
          width:  6px;
          height: 6px;
          background-color: #000;
          margin-right: 22px;
          border-radius: 50%;
          margin-top: 9px;
        }
        .title{
          font-size: 16px;
          color: #1F1E26;
        }
      }
      .features_discribe{
        display: flex;
        text-align: left;
        color: #666666;
        padding:10px 26px 26px 36px;
      }
    }

  }
}
.customer{
  width: 100%;
  background: #F5F9FF;
  padding: 60px 0 100px 0 ;
  .top{

    .title{
      font-size: 40px;
      font-weight: 550;
      line-height: 55px;
      margin-top: 20px;
    }
    .discribe{
      color: #ccc;
      font-size: 24px;
      margin-top: 9px;
    }
  }
  .features{
    width: 100%;
    //height: 777px;
    display: flex;
    padding-bottom: 114px;
    margin-top: 80px;
    flex-direction: column;
    align-items: center;
    position: relative;
    .bgSite{
      position: absolute;
      bottom: 17px;
      width: 100%;
      height: 124px;
      background: #1C51A3;
    }
    .content_item{
      width: 1172px;
      //height: 136px;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.08);
      border-radius: 10px;
      margin-bottom: 20px;
      .item_top{
        display: flex;
        padding:41px 0 0px 36px;
        .dot{
          width:  6px;
          height: 6px;
          background-color: #000;
          margin-right: 22px;
          border-radius: 50%;
          margin-top: 9px;
        }
        .title{
          font-size: 16px;
          color: #1F1E26;
        }
      }
      .features_discribe{
        display: flex;
        text-align: left;
        color: #666666;
        padding:16px 0 16px 36px;
      }
    }

  }
  .Documentation{
    display: flex;
    justify-content: center;
    margin-top: 80px;
  .Documentation_item{
    text-align: left;
    width: 380px;
    padding-bottom: 100px;
    //height: 460px;
    margin-left: 10px;
    background: #FFFFFF;
    .top{
      height: 105px;
      background-image: url("https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/12360456-ac45-4a1f-b042-ef421059abec.png");
      background-size: 100% 100%;
      p{
        font-size: 24px;
        color: #FFFFFF;
        padding: 36px 0 0 40px;
      }
    }
    .content{
      padding: 62px 0 0 40px;
      .content_top{
        font-weight: 550;
        font-size: 20px;
        color: #1C51A3;
      }
      .content_center{
        margin-top: 32px;
        .item{
          margin-bottom: 20px;
          font-weight: 400;
          font-size: 18px;
          color: #21335B;
        }
        .item:hover{
          //font-weight: 550;
            color: #2F99F1;
            cursor: pointer;
        }
      }
    }
  }
  }
}
.advantages{
  width: 100%;
  margin-top: 80px;
  text-align: center;
  .showAllBtn{
    width: 156px;
    height: 46px;
    margin-bottom: 40px;
    background: #1C51A3;
    color:#fff;
    border: none;
    //font-weight: 550;
    font-size: 18px;
    border-radius: 8px;
  }
  .top{
    .title{
      font-size: 40px;
      font-weight: 550;
      line-height: 55px;
      margin-top: 80px;
    }
    .discribe{
      color: #ccc;
      font-size: 24px;
      margin-top: 9px;
    }
  }
  .video_content{
    width: 1176px;
    display: flex;
    margin: 80px auto 0 auto;
    justify-content: space-between;
    padding-bottom: 60px;
    flex-wrap: wrap;

    .video_content_item{
      margin-bottom: 20px;
      position: relative;
      height: 288px;
      box-shadow: 0px 0px 30px 0px rgba(28,81,163,0.1);
      p{
        height: 60px;
        line-height: 78px;
        background-color: #fff;
        color: #21335B;
      }
      .video_icon{
        z-index: 2;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-80%);
        transition: z-index 0.3s ease;
      }
    }
    .video_img{
      position: relative;
      z-index: 2;
      width: 360px;
      height: 200px;
      transition: height 0.3s ease, z-index 0.3s ease;
    }
    .video_img:hover {
      height: 240px;
    }
    .video_img:hover + p{
      height: 48px;
      line-height: 48px;
      transition: height 0.3s ease;
    }
  }
  .content{
    width: 1176px;
    display: flex;
    margin: 80px auto 0 auto;
    justify-content: space-around;
    flex-wrap: wrap;
    //align-items: center;
    .content_item{
      width: 350px;
      height: 353px;
      display: flex;
      margin-bottom: 20px;
      flex-direction: column;
      p{
        max-width: 240px;
        font-size: 18px;
        display: flex;
        text-align: center;
        font-family: Simsun,sans-serif;
        flex-wrap: wrap;
        word-wrap:break-word;
        word-break:normal;
        margin: 28px auto 0 auto;
        padding-bottom: 28px;
        color: #21335B;
      }
      //justify-content: center;
      align-items: center;
      text-align: center;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px 0px rgba(28,81,163,0.1);
      border-radius: 10px;
      img{
          width: 148px;
          height: 148px;
        //margin-top: 36px;
      }
      .item_content{
        P{
          margin-top: 20px;
          font-size: 14px;
          color: #6D7B9C;
          padding: 0 30px;
          text-align: justify;
      }}
    }
    .content_item_2{
      width: 350px;
      height: 353px;
      margin-bottom: 20px;
      border-radius: 10px;
      box-shadow: 0px 0px 30px 0px rgba(28,81,163,0.1);

      img{
        width: 350px;
        height: 200px;
      }
      .item_content{
        padding: 0 30px;
        p:nth-child(1){
          font-size: 18px;
          margin-top: 28px;
          padding-bottom: 20px;
          color: #21335B;
        }
        p:nth-child(2){
          word-wrap:break-word;
          word-break:normal;
          text-align: center;
          padding-bottom: 10px;
          height: auto;
          //margin-top: 20px;
          font-size: 14px;
          color: #6D7B9C;
        }
      }
    }
  }
}
	.jobs {
		width: 100%;
		height: 1328px;
    margin-top: -80px;
    position: relative;
		//background: url("../../../static/image/bg_img/02.png") no-repeat;
		//background-size: 110% 100%;

		.jobs_contents {
			width: 1200px;
			margin: 0 auto;
			padding: 70px 0;
			box-sizing: border-box;

			.desc {
				font-size: 22px;
				font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
				font-weight: normal;
				color: #CCCCCC;
				line-height: 33px;
				margin-top: 15px;
				margin-bottom: 70px;
			}

			.jobTabs {
				width: 100%;
				overflow: hidden;

				.tab {
					min-width: 120px;
					height: 52px;
					background: #ebebeb;
					color: #666;
					font-size: 15px;
					border-radius: 4px;
					line-height: 52px;
					margin-right: 10px;
					cursor: pointer;
				}

				.tab:hover {
					background-color: #1768E4;
					color: #fff;
					opacity: 0.8;
				}

				.active {
					background: #1768E4;
					color: #fff;
				}
			}

			.typeCard {
				width: 380px;
				height: 345px;
				background: #FFFFFF;
				box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
				border-radius: 8px;
				cursor: pointer;

				.cover {
					width: 380px;
					height: 260px;
					border-radius: 5px;
				}
			}

			.jobListBox {
				width: 49%;
				height: 113px;
				background-color: #fff;
				box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.05);
				border: 1px solid #eee;
				border-radius: 8px;
				margin-bottom: 20px;
				padding: 15px;
				box-sizing: border-box;

				.title {
					color: #333;
					font-size: 18px;
					font-weight: 700;
				}

				.salary {
					color: #ff0000;
					font-size: 19px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FF0000;
					line-height: 26px;
					text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
				}

				.tags {
					height: 22px;
					line-height: 22px;
					background: #F1F5F9;
					box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
					border-radius: 11px;
					font-size: 14px;
					margin: 5px 5px 5px 0;
					padding: 0 8px;
				}

				.company {
					margin-top: 3px;
					color: #929292;
					font-size: 14px;
					display: flex;
				}

				.signBtn {
					height: 26px;
					line-height: 28px;
					background: #1768E4;
					box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
					border-radius: 5px;
					border: 0;
					color: #fff;
					font-size: 13px;
					padding: 0 10px;
					cursor: pointer;
				}
				.signBtn:hover{
					background-color: #1768E4;
					opacity: 0.8;
				}
			}
		}
	}

	.card {
		width: 380px;
		height: 260px;
		border-radius: 10px;
		background: #f5f5f5;
		position: relative;
		border: 3px solid #eee;
		transition: 0.5s ease-out;
		overflow: visible;
	}

	.card-details {
		color: black;
		height: 100%;
		gap: .5em;
		display: grid;
		place-content: center;
	}

	.card-button {
		transform: translate(-50%, 125%);
		width: 60%;
		border-radius: 1rem;
		border: none;
		background-color: #008bf8;
		color: #fff;
		font-size: 1rem;
		padding: .5rem 1rem;
		position: absolute;
		left: 50%;
		bottom: 0;
		opacity: 0;
		transition: 0.3s ease-out;
	}

	.text-body {
		color: rgb(134, 134, 134);
	}

	/*Text*/
	.text-title {
		font-size: 1.5em;
		font-weight: bold;
	}

	/*Hover*/
	.card:hover {
		border-color: #008bf8;
		box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
	}

	.card:hover .card-button {
		transform: translate(-50%, 50%);
		opacity: 1;
	}

	.loader {
	  width: 60px;
	  height: 60px;
	  display: grid;
	  border: 4.6px solid #0000;
	  border-radius: 100%;
	  border-color: #008cff #0000;
	  animation: spinner-e04l1k 1.5s infinite linear;
	}

	.loader::before, .loader::after {
	  content: "";
	  grid-area: 1/1;
	  margin: 8px;
	  border: inherit;
	  border-radius: 50%;
	}

	.loader::before {
	  border-color: #048be6 #0000;
	  animation: inherit;
	  animation-duration: 0.8s;
	}

	.loader::after {
	  margin: 2.9px;
	}

	@keyframes spinner-e04l1k {
	  100% {
	    transform: rotate(1turn);
	  }
	}

</style>
